import type { useTranslations } from 'next-intl';
import { SITE } from '@/app/constants';
import type { SupportedLanguage } from '@/app/types';

export const getHeaderTabsConfig = (t: ReturnType<typeof useTranslations<'header'>>, locale: SupportedLanguage) => [
  {
    label: t('tabs.features.label'),
    key: 'features',
    href: '',
    icon: '',
    children: [
      {
        label: t('tabs.features.reference'),
        key: 'character2video',
        href: SITE === 'china' ? '/create/character2video' : '/ai-reference-to-video',
      },
      {
        label: t('tabs.features.image'),
        key: 'img2video',
        href: SITE === 'china' ? '/create/img2video' : '/ai-image-to-video',
      },
      {
        label: t('tabs.features.text'),
        key: 'text2video',
        href: SITE === 'china' ? '/create/text2video' : '/ai-text-to-video',
      },
      ...(SITE === 'global'
        ? [
            {
              label: t('tabs.features.sound'),
              key: 'ai-sound-effect-generator',
              href: '/ai-sound-effect-generator',
            },
            {
              label: t('tabs.features.image-generator'),
              key: 'ai-image-generator',
              href: '/ai-image-generator',
            },
            {
              label: t('tabs.features.vidu-q3'),
              key: 'vidu-q3',
              href: '/vidu-q3',
            },
          ]
        : []),
      {
        label: t('tabs.templates.label'),
        key: 'Templates',
        href: '/templates',
      },
      {
        label: t('tabs.features.vidu-claw'),
        key: 'vidu-claw',
        href: '/vidu-claw',
      },
    ],
  },
  {
    label: t('tabs.features.vidu-stream'),
    key: 'vidu-stream',
    icon: '',
    href: '/vidu-stream',
  },
  {
    label: t('tabs.pricing.label'),
    key: 'Pricing',
    icon: '',
    href: '/pricing',
  },
  SITE === 'global' && {
    label: t('tabs.creatorPlan.label'),
    key: 'creatorPlan',
    icon: '',
    href: '',
    children: [
      {
        label: t('tabs.creatorPlan.viduCPP'),
        key: 'viduCPP',
        href: '/cpp',
      },
      {
        label: t('tabs.creatorPlan.viduEarn'),
        key: 'viduEarn',
        href: '/vidu-earn',
      },
    ],
  },
  {
    label: t('tabs.api.label'),
    key: 'api',
    icon: '',
    href: SITE === 'china' ? 'https://platform.vidu.cn/' : 'https://platform.vidu.com/',
  },
  {
    label: t('tabs.joinUs.label'),
    key: 'joinUs',
    icon: '',
    href: 'https://shengshu.jobs.feishu.cn/index/',
  },
  // Temporarily hide the Vidu Earn entry from the public header.
  // {
  //   label: t('tabs.viduEarn.label'),
  //   key: 'viduEarn',
  //   icon: '',
  //   href: '/earn',
  // },
  {
    label: t('tabs.support.label'),
    key: 'support',
    href: '',
    icon: '',
    children: [
      {
        label: t('tabs.support.helpCenter'),
        key: 'Help Center',
        href: '/help-center',
      },
      ['en', 'ja'].includes(locale) && {
        label: t('tabs.support.aiTemplates'),
        key: 'AI Templates',
        href: '/ai-templates',
      },
      {
        label: t('tabs.support.tutorial'),
        key: 'Tutorial',
        href: '/home/tutorial',
      },
      ['en', 'ja'].includes(locale) && {
        label: t('tabs.support.blog'),
        key: 'Blog',
        href: '/blog',
      },
    ],
  },
];
